import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Globe, Download } from 'lucide-react';

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);
// import LogoPng from '../assets/InitX_Logo.png';

const Connect = () => {
  const handleSaveContact = () => {
    const vcf = `BEGIN:VCARD
VERSION:3.0
FN:InitX Technologies
ORG:InitX Technologies
TITLE:Initiating Innovation with Expertise
TEL;TYPE=WORK,VOICE:+918986283243
EMAIL;TYPE=WORK:contact@initx.online
URL:https://initx.online
ADR;TYPE=WORK:;;Sasaram;Bihar;;821115;India
NOTE:MSME Registered Enterprise
END:VCARD`;
    const blob = new Blob([vcf], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'InitX_Technologies.vcf';
    a.click();
    URL.revokeObjectURL(url);
  };

  const services = [
    { icon: '💻', label: 'Web Dev' },
    { icon: '🤖', label: 'AI & ML' },
    { icon: '☁️', label: 'Cloud' },
    { icon: '📱', label: 'Mobile Apps' },
    { icon: '🏛️', label: 'Architecture' },
    { icon: '🔒', label: 'Cybersecurity' },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '20px 16px 40px',
      fontFamily: "'Inter', system-ui, sans-serif"
    }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ width: '100%', maxWidth: '420px' }}
      >
        {/* Header Card */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(0,212,255,0.15) 0%, rgba(59,130,246,0.15) 100%)',
          border: '1px solid rgba(0,212,255,0.3)',
          borderRadius: '24px',
          padding: '32px 24px',
          textAlign: 'center',
          marginBottom: '16px',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 0 40px rgba(0,212,255,0.1)'
        }}>
          {/* <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2 }}
            // src={LogoPng}
            alt="InitX Technologies"
            style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '16px' }}
          /> */}
          <h1 style={{ color: '#fff', fontSize: '1.8rem', fontWeight: '800', margin: '0 0 4px' }}>InitX Technologies</h1>
          <p style={{ color: '#00d4ff', fontSize: '0.9rem', fontWeight: '600', margin: '0 0 12px', letterSpacing: '0.5px' }}>
            Initiating Innovation with Expertise
          </p>

        </div>

        {/* Quick Action Buttons */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '16px' }}>
          {[
            { icon: <Phone size={20} />, label: 'Call Now', color: '#22c55e', href: 'tel:+918986283243' },
            { icon: <WhatsAppIcon />, label: 'WhatsApp', color: '#25d366', href: 'https://wa.me/918986283243' },
            { icon: <Mail size={20} />, label: 'Email Us', color: '#00d4ff', href: 'mailto:contact@initx.online' },
            { icon: <Globe size={20} />, label: 'Website', color: '#818cf8', href: 'https://initx.online' },
          ].map((btn, i) => (
            <motion.a
              key={i}
              href={btn.href}
              target={btn.href.startsWith('http') ? '_blank' : undefined}
              rel="noreferrer"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * i + 0.3 }}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                gap: '8px', padding: '18px 12px',
                background: 'rgba(255,255,255,0.05)', border: `1px solid ${btn.color}40`,
                borderRadius: '16px', color: btn.color, textDecoration: 'none',
                fontWeight: '700', fontSize: '13px', transition: 'all 0.2s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={e => e.currentTarget.style.background = `${btn.color}20`}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
            >
              {btn.icon}
              {btn.label}
            </motion.a>
          ))}
        </div>

        {/* Save Contact Button */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          onClick={handleSaveContact}
          style={{
            width: '100%', padding: '16px',
            background: 'linear-gradient(135deg, #0ea5e9 0%, #00d4ff 50%, #3b82f6 100%)',
            border: 'none', borderRadius: '16px', color: '#fff',
            fontWeight: '700', fontSize: '15px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
            marginBottom: '16px', boxShadow: '0 4px 20px rgba(0,212,255,0.3)',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <Download size={18} /> Save Contact
        </motion.button>

        {/* Services */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          style={{
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(0,212,255,0.2)',
            borderRadius: '20px', padding: '20px', marginBottom: '16px'
          }}
        >
          <p style={{ color: '#94a3b8', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 16px', textAlign: 'center' }}>What We Do</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
            {services.map((s, i) => (
              <div key={i} style={{
                textAlign: 'center', padding: '12px 8px',
                background: 'rgba(0,212,255,0.05)', borderRadius: '12px',
                border: '1px solid rgba(0,212,255,0.1)'
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>{s.icon}</div>
                <div style={{ color: '#cbd5e1', fontSize: '11px', fontWeight: '600' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Locations */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
          style={{
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(0,212,255,0.2)',
            borderRadius: '20px', padding: '20px', marginBottom: '16px'
          }}
        >
          <p style={{ color: '#94a3b8', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 14px', textAlign: 'center' }}>Our Offices</p>
          {[
            // { label: 'Registered Office', location: 'Sasaram, Bihar - 821115' }, // Hidden
            { label: 'Corporate Office', location: 'Lucknow, Uttar Pradesh - 226001' },
          ].map((office, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: i === 0 ? '12px' : '0' }}>
              <MapPin size={16} style={{ color: '#00d4ff', marginTop: '2px', flexShrink: 0 }} />
              <div>
                <div style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '600' }}>{office.label}</div>
                <div style={{ color: '#fff', fontSize: '13px', fontWeight: '500' }}>{office.location}</div>
              </div>
            </div>
          ))}
        </motion.div>

        {/* Social Links */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginBottom: '24px' }}
        >
          {[
            { icon: <LinkedInIcon />, href: 'https://www.linkedin.com/company/initxtechnologies/', color: '#0077b5' },
            { icon: <InstagramIcon />, href: 'https://instagram.com/initxtechnologies', color: '#e1306c' },
            { icon: <FacebookIcon />, href: 'https://facebook.com/initxtech', color: '#1877f2' },
            { icon: <XIcon />, href: 'https://twitter.com/initxtech', color: '#e7e9ea' },
          ].map((s, i) => (
            <a key={i} href={s.href} target="_blank" rel="noreferrer" style={{
              width: '48px', height: '48px', borderRadius: '50%',
              background: `${s.color}20`, border: `1px solid ${s.color}50`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: s.color, textDecoration: 'none', transition: 'all 0.2s ease'
            }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >
              {s.icon}
            </a>
          ))}
        </motion.div>

        {/* Footer */}
        <p style={{ textAlign: 'center', color: '#475569', fontSize: '12px', margin: 0 }}>
          © 2026 InitX Technologies · <a href="https://initx.online" style={{ color: '#00d4ff', textDecoration: 'none' }}>initx.online</a>
        </p>
      </motion.div>
    </div>
  );
};

export default Connect;
